const limit = (str = '') => {
  return str?.length > 10 ? str?.substr(0, 10) + '...' : str;
};

const formatPosition = (
  parent_department = '',
  department = '',
  position = ''
): string => {
  parent_department = limit(parent_department);
  department = limit(department);
  position = limit(position);

  // return `${parent_department}${
  //   parent_department && (department || position) ? ' | ' : ''
  // }${department}${department && position ? ' | ' : ''}${position}`;
  return `${department}${department && position ? ' | ' : ''}${position}`;
};

export default formatPosition;
